/** The messages of a ValidationProblem response (`{ errors: { Field: ['message'] } }`), or [] for any other failure. */
export function validationMessages(error: unknown): string[] {
  const errors = (error as { error?: { errors?: unknown } } | null | undefined)?.error?.errors;
  return errors && typeof errors === 'object'
    ? Object.values(errors).flat().filter((detail): detail is string => typeof detail === 'string' && !!detail.trim())
    : [];
}

/**
 * Why the paywall could not load, for the editor's preview only: the admin can fix the setup (Stripe, order
 * settings, whitelisted domains) themselves. Buyers only get the general message.
 */
export function loadErrorReasons(error: unknown): string[] {
  const messages = validationMessages(error);
  if (messages.length) {
    return messages;
  }
  switch ((error as { status?: number } | null | undefined)?.status) {
    case 0:
      return ['The paywall API could not be reached.'];
    case 403:
      return ["This page's address is not in the paywall's whitelisted domains."];
    case 404:
      return ['The paywall was not found. It may have been deleted.'];
    default:
      return [];
  }
}
